/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-07-27 16:44:55
 * @LastEditors: linxi
 * @LastEditTime: 2023-03-02 11:16:18
 */
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import styles from './Tenants.module.css'
import { orderColumns } from './columns'
import { EditableList } from '../../compnents/list/EditableList'
import {
  Button,
  Form,
  Input,
  Row,
  Space,
  Cascader as Cascaded,
  Select,
  notification,
} from 'antd'
import { CaretDownFilled, SearchOutlined } from '@ant-design/icons'
import {
  getAddOrder,
  getAllList,
  getOrderDetailExport,
  getOrderList,
  getOrderPriceList,
  getTenantList,
} from './tenantSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { ThemeContext } from '../../theme/ThemeContext'
import {
  getTenantCategoryName,
  TenantCategories,
  TenantCategory,
} from '../../models/tenant'
import {
  DateSelect,
  DateRangeFieldName,
  DateRangeType,
} from '../../compnents/form/DateSelect'
import { ProductPriceModal } from './productPriceModal'
import { traceRoute } from '../../layouts/layoutSlice'
import { OrderAddModal } from './orderAddModal'
import { OrderEditModal } from './OrderEditModal'
import { stringTrim } from '../../utils/StringUtils'
import { PurchaseModal } from '../../compnents/importModal/purchaseModal'
interface OrderManagementProps {
  state: string
}

export const OrderManagement = ({
  state,
}: OrderManagementProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const theme = useContext(ThemeContext)

  const [pageLoading, setPageLoading] = useState(false)

  const [params, setParams] = useState<any>({
    current: 0,
    size: 10,
  })

  console.log(state, 'state')

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })

  const [allList, setAllList] = useState<any[]>() //省市数据

  const [productPriceModal, setProductPriceModal] = useState(false) //产品价格表弹窗显示

  const [productPriceModalList, setProductPriceModalList] = useState([]) //产品价格表弹窗数据

  const [orderAddeModal, setOrderAddeModal] = useState(false) //新增订单弹窗显示

  const [orderEditModal, setOrderEditModal] = useState(false) //修改订单弹窗显示
  const [editRecord, setEditRecord] = useState<any>({}) //当前编辑的订单记录

  const [defaultProductId, setDefaultProductId] = useState<number | undefined>(undefined) //默认选中的产品ID

  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname) || '{}'
  ) //当前页面缓存数据

  const loadData = (selectedOptions: any) => {
    const targetOption = selectedOptions[selectedOptions.length - 1]
    targetOption.loading = true
  }

  const [isPurchaseModalVisible, setIsPurchaseModalVisible] = useState(false) // 控制导入弹窗是否显示

  useEffect(() => {
    if (Object.keys(storageParams).length && state == storageParams.state) {
      form.setFieldsValue({
        ...storageParams,
        endTimeHead: storageParams.createStartTime,
        endTimeTail: storageParams.createEndTime,
      })
    }
    form.submit()
  }, [])

  useEffect(() => {
    //获取省市数据
    dispatch(getAllList())
      .then(unwrapResult)
      .then((t: any) => {
        setAllList(t)
      })
  }, [])

  const getPageList = () => {
    setPageLoading(true)
    dispatch(
      getOrderList({
        ...params,
        area: undefined,
        provinceCode: params?.area?.slice(0, 1)[0],
        cityCode: params?.area?.slice(1, 2)[0],
        countyCode: params?.area?.slice(2, 3)[0],
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          total: res.total,
          items: res.records,
        })
      })
      .finally(() => setPageLoading(false))
  }

  useEffect(() => {
    params.current &&
      sessionStorage.setItem(
        location.pathname,
        JSON.stringify({ ...params, state })
      ) //数据缓存
  }, [params, state])
  useEffect(() => {
    if (params.current != 0) {
      getPageList()
    }
  }, [params])

  useEffect(() => {
    //产品价格
    dispatch(getOrderPriceList())
      .then(unwrapResult)
      .then((res: any) => setProductPriceModalList(res))
  }, [])

    const ListExport = () => {
      dispatch(getOrderDetailExport({
        ...params,
        area: undefined,
        provinceCode: params?.area?.slice(0, 1)[0],
        cityCode: params?.area?.slice(1, 2)[0],
        countyCode: params?.area?.slice(2, 3)[0],
      }))
        .then(unwrapResult)
        .then((res: any) => {
          console.log(res, 'res')
          const content = res
          const blob = new Blob([content])
          const fileName = '订单管理导出数据.xlsx'
          const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
          const elink = document.createElement('a')
          if ('download' in elink) {
            elink.download = fileName
            elink.style.display = 'none'
            elink.href = selfURL['createObjectURL'](blob)
            document.body.appendChild(elink)
            // 触发链接
            elink.click()
            selfURL.revokeObjectURL(elink.href)
            document.body.removeChild(elink)
          } else {
            navigator.msSaveBlob(blob, fileName)
          }
        })
        .then(() => {
          notification.success({
            message: '导出成功',
            duration: 3,
          })
        })
        .catch((res: any) => {
          console.log('失败')
        })
    }


  return (
    <>
      {/* 按钮 */}
      <Space className={styles.btnWrap}>
        <Button type='primary' onClick={() => setIsPurchaseModalVisible(true)}>
          导入订单
        </Button>
        <Button
          type='primary'
          onClick={() => {
            ListExport()
            console.log(1111111)
          }}
        >
          导出订单
        </Button>
        <Button type='primary' onClick={() => setOrderAddeModal(true)}>
          新增订单
        </Button>
        <Button type='primary' onClick={() => { setDefaultProductId(1); setOrderAddeModal(true) }}>
          新增系统续费
        </Button>
        <Button type='primary' onClick={() => { setDefaultProductId(2); setOrderAddeModal(true) }}>
          新增系统赠送
        </Button>
        <Button type='primary' onClick={() => { setDefaultProductId(23); setOrderAddeModal(true) }}>
          新增vpn专线
        </Button>
        <Button type='primary' onClick={() => { setDefaultProductId(25); setOrderAddeModal(true) }}>
          新增医保服务
        </Button>
        <Button type='primary' onClick={() => setProductPriceModal(true)}>
          产品价格表
        </Button>
        <Button
          type='primary'
          onClick={() => {
            dispatch(
              traceRoute({
                name: '价格设置',
                path: '/admin/tenant/PriceSet',
                // query: `id=${r.id}`,
              })
            )
          }}
        >
          续订价格设置
        </Button>
      </Space>

      <div className={styles.wrap}>
        {/* 筛选查询区域 */}
        <Form
          form={form}
          autoComplete='off'
          onFinish={(values) => {
            setParams({
              ...params,
              ...values,
              tenantCategory:
                values.tenantCategory === TenantCategory.All
                  ? undefined
                  : values.tenantCategory,
              createStartTime: values.endTimeHead,
              createEndTime: values.endTimeTail,
              endTimeHead: undefined,
              endTimeTail: undefined,
              current: storageParams.current ? storageParams.current : 1,
            })
          }}
        >
          <Row
            justify='space-between'
            align='middle'
            className={styles.queryWrap}
          >
            <Space>
              <Form.Item
                name='tenantName'
                noStyle
                getValueFromEvent={stringTrim}
              >
                <Input
                  allowClear
                  placeholder='请输入机构名称'
                  prefix={<SearchOutlined />}
                  onChange={form.submit}
                />
              </Form.Item>

              <Form.Item name='payId' noStyle getValueFromEvent={stringTrim}>
                <Input
                  allowClear
                  placeholder='请输入支付id'
                  prefix={<SearchOutlined />}
                  onChange={form.submit}
                />
              </Form.Item>

              <Form.Item name='area' noStyle>
                <Cascaded
                  loadData={loadData}
                  changeOnSelect
                  suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
                  options={allList}
                  style={{ width: '13rem' }}
                  onChange={form.submit}
                  placeholder='请选择省市区'
                />
              </Form.Item>

              <Form.Item name='productId' noStyle>
                <Select
                  placeholder='产品类型-全部'
                  style={{ width: '13rem' }}
                  onChange={form.submit}
                  allowClear
                >
                  {productPriceModalList?.map((el: any) => (
                    <Select.Option key={el.id} value={el.id}>
                      {el.productName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name='duration' noStyle>
                <Select
                  suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
                  placeholder='时长'
                  allowClear
                  onChange={form.submit}
                  style={{ width: '13rem' }}
                >
                  <Select.Option value={0}>一年以下</Select.Option>
                  <Select.Option value={1}>1年</Select.Option>
                  <Select.Option value={2}>2年</Select.Option>
                  <Select.Option value={3}>3年</Select.Option>
                  <Select.Option value={99}>3年以上</Select.Option>
                </Select>
              </Form.Item>

              <DateSelect
                options={[
                  DateRangeType.Today,
                  DateRangeType.Yesterday,
                  DateRangeType.ThisWeek,
                  DateRangeType.ThisMonth,
                  DateRangeType.NextMonth,
                  DateRangeType.ThisYear,
                  DateRangeType.Range,
                ]}
                style={{ width: '13rem' }}
                labelPrefix=''
                placeholder='创建日期'
                namePrefix='endTime'
                onChange={form.submit}
              />
            </Space>
            <Button type='primary' onClick={form.submit}>
              查询
            </Button>
          </Row>
        </Form>

        {/* 表格区域 */}
        <div className={styles.tableWrap}>
          <EditableList
            page={{
              current: params.current,
              size: params.size,
              total: page.total,
              items: page.items,
            }}
            loading={pageLoading}
            className={styles.table}
            columns={orderColumns((t: any) => {
              console.log(t)
            }, params.size * (params.current - 1))}
            onChangePage={(current: number, size?: number) => {
              setParams({
                ...params,
                current,
                size,
              })
            }}
            onRow={(t: any) => ({
              onDoubleClick: () => {
                setEditRecord(t)
                setOrderEditModal(true)
              },
            })}
          />
        </div>

        {/* 新增订单弹窗区域 */}
        <OrderAddModal
          visible={orderAddeModal}
          productPriceModalList={productPriceModalList}
          defaultProductId={defaultProductId}
          onOk={(obj) => {
            dispatch(getAddOrder(obj))
              .then(unwrapResult)
              .then((res: any) => {
                setParams({ ...params, current: 1 })
                notification.success({ message: '新增成功' })
              })
              .finally(() => {
                dispatch(
                  //机构管理表格防止冲突
                  getTenantList({ current: 1 })
                )
                setDefaultProductId(undefined)
                setOrderAddeModal(false)
              })
          }}
          onCancel={() => {
            dispatch(getTenantList({ current: 1 }))
            setDefaultProductId(undefined)
            setOrderAddeModal(false)
          }}
        />
        {/* 修改订单弹窗 */}
        <OrderEditModal
          visible={orderEditModal}
          record={editRecord}
          params={params}
          onRefresh={() => getPageList()}
          onCancel={() => {
            setOrderEditModal(false)
            setEditRecord({})
          }}
        />
        {/* 产品价格表弹窗区域 */}
        <ProductPriceModal
          visible={productPriceModal}
          productPriceModalList={productPriceModalList}
          onCancel={() => setProductPriceModal(false)}
        />
        {/* 订单导入 */}
        <PurchaseModal
          state={7}
          isPurchaseModalVisible={isPurchaseModalVisible}
          onOk={() => {
            setIsPurchaseModalVisible(false)
            getPageList()
          }}
          onCancel={() => {
            setIsPurchaseModalVisible(false)
          }}
        />
      </div>
    </>
  )
}
